export class ComboOffer {
    offerType: string;
    offerValue: number;
    minimumQty: number;
    conditionType: string;
    categoryId: string;
}